import React, { useContext, useEffect, useState } from 'react';

import { Styled } from './Navigation.styles';
import { mainCordovaContext, bcContext } from '../context';
import { useHistory } from 'react-router';
import { PageHeader } from '../components/PageHeader';
import { Data, Task } from 'views/pages/ControllerTask/Details/Details.types';
import { secureRequest } from 'utils/request';
import { BCRoute } from './Navigation.types';
import { Page } from '../components/Page';
import {LogoutButton, NavigationButton} from "../components/NavigationButton";

const bcRoutes: BCRoute[] = [
  {
    url: '/bc/departmentcontroll',
    name: 'Текущий процесс контроля',
  },
  {
    url: '/bc/controllertask',
    name: 'Наряд-задания',
    taskRequired: true,
  },
  {
    url: '/bc/currentregion',
    name: 'Районы контроля',
    taskRequired: true,
  },
  {
    url: '/bc/result',
    name: 'Результаты ПБК',
    taskRequired: true,
  },
];

export const BCNavigation: React.FC = () => {
  const { toggleNavigation } = useContext(mainCordovaContext);
  const { setTask, task } = useContext(bcContext);
  const history = useHistory();

  useEffect(() => {
    const request = async () => {
      const data = await secureRequest<Data>(
        '/api/v1/pass/controllertask/worker'
      );

      if (data && data.task) {
        setTask(data.task);
      }
    };
    request();
  }, [setTask]);
  
  return (
    <Page
      title="ПБК"
      primaryButtonNode={<NavigationButton />}
      actionButton={<LogoutButton />}
    >
      <Styled.Navigation>
        {bcRoutes.map(({ name, url, taskRequired }) => {
          if (taskRequired && !task) return null;
          return (
            <Styled.NavButton key={url} to={url}>
              {name}
            </Styled.NavButton>
          );
        })}
      </Styled.Navigation>
    </Page>
  );
};
